angular
  .module("bot")

  .directive("botMenuButton", $window => {
    return {
      restrict: "E",
      template: `<button type="button" class="bot-menu-button" ng-class="{'start-again': isStartAgain }" ng-show="menuItem" ng-click="click()" ng-disabled="disable">{{ label }}</button>`,
      replace: true,
      scope: {
        menuItem: "=",
        handler: "=",
        disable: "=",
      },
      link: scope => {
        let menuItem = scope.menuItem;
        scope.isStartAgain = menuItem.label === 'Start again';
        scope.label = menuItem.label;
        scope.click = () => {
          if (menuItem.href) {
            return ($window.location.href = menuItem.href);
          }
          scope.handler(menuItem.content, menuItem.key);
        };
      },
    };
  });
